<template>
  <sa-page-layout ref="cmpSaPageLayout" :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
    <template slot="toolbar">
      <b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickCambiaStato"><i class="fas fa-exchange-alt"></i>Cambia Stato </b-button>
      <b-button variant="outline-success btn-toolbar sa-margin-left float-sm-left" class="my-2 my-sm-0" :hidden="btnAssociaClienteHidden" @click="onClickAssociaCliente"> <i class="fas fa-user-tie"></i> Associa Cliente </b-button>
    </template>
    <template slot="table-header">
      <gestione-attivita-progetto-view-component ref="cmpGestioneAttivitaProgettoViewComponent" @updateJsonData="onUpdateJsonDataProdotto"></gestione-attivita-progetto-view-component>
    </template>
    <template slot="table-body">
      <b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab>
          <template #title> <i class="fas fa-user-tie"></i><span style="padding-left: 10px">Clienti</span> </template>
          <gestione-attivita-clienti-list-component :patNoteResources="patNoteResources" ref="cmpGestioneAttivitaClientiListComponent" @afterRimuoviAssociazione="onAfterRimuoviAssociazioneCliente"></gestione-attivita-clienti-list-component>
        </b-tab>
        <b-tab>
          <template #title> <i class="fas fa-list-ol"></i><span style="padding-left: 10px">Attività</span> </template>
          <gestione-attivita-attivita-list-component ref="cmpGestioneAttivitaAttivitaListComponent"></gestione-attivita-attivita-list-component>
        </b-tab>
        <b-tab>
          <template #title> <i class="fas fa-history"></i><span style="padding-left: 10px">Storico degli Stati</span> </template>
          <storico-stati-component ref="cmpStoricoStatiComponent"></storico-stati-component>
        </b-tab>
        <gestione-attivita-clienti-list-select-modal ref="cmpGestioneAttivitaClientiListSelectModal" @associzioneAvvenuta="onAssocizioneClienteAvvenuta"></gestione-attivita-clienti-list-select-modal>
        <modal-error ref="cmpModalError"></modal-error>
        <state-change-modal-component ref="cmpStateChangeModalComponent" @cambioStatoSuccess="onCambioStatoSuccess"></state-change-modal-component>
      </b-tabs>
    </template>
  </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GestioneAttivitaProgettoViewComponent from "../components/GestioneAttivitaProgettoViewComponent.vue";
import GestioneAttivitaClientiListComponent from "../components/GestioneAttivitaClientiListComponent.vue";
import GestioneAttivitaClientiListSelectModal from "../components/GestioneAttivitaClientiListSelectModal.vue";
import GestioneAttivitaAttivitaListComponent from "../components/GestioneAttivitaAttivitaListComponent.vue";
import StateChangeModalComponent from "../../utility/components/StateChangeModalComponent.vue";
import StoricoStatiComponent from "../../utility/components/StoricoStatiComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
  mixins: [UtilityMixin],
  components: { SaPageLayout, StateChangeModalComponent, ModalError, GestioneAttivitaProgettoViewComponent, GestioneAttivitaClientiListComponent, GestioneAttivitaAttivitaListComponent, GestioneAttivitaClientiListSelectModal, StoricoStatiComponent },
  data() {
    return {
      activeTabIndex: 0,
      showModalLoading: false,
      btnAssociaClienteHidden: false,
      linkback: "/gestioneattivita/attivita",
      pathResource: "/gestioneattivitaattivita",
      pathResourceClientiAsset: "/gestioneattivitaclienti/clienti",
      pathResourceStatiStorico: "/gestioneattivitaassetsstatistorico",
      patNoteResources: "/gestioneattivitaclientiasset",
      pathResourceStati: "/gestioneattivitastati",
      pathResourceAggiornaStato: "/gestioneattivitaassetsstatistorico",
      jsonData: null,
      idAsset: null,
    };
  },
  mounted() {
    this.idAsset = this.$route.params.id;
    this.$refs.cmpGestioneAttivitaClientiListComponent.loadFromAsset(this.pathResourceClientiAsset + "/" + this.idAsset, {});
  },
  methods: {
    onUpdateJsonDataProdotto() {
      //console.log("OK");
    },
    onInputTabs(index) {
      console.log(index);
      switch (index) {
        case 0:
          this.btnAssociaClienteHidden = false;
          break;
        case 1:
          this.btnAssociaClienteHidden = true;

          // this.btnAssociaProdottoHidden = false;
          // this.btnAssociaProgettoHidden = true;
          this.$refs.cmpGestioneAttivitaAttivitaListComponent.loadFromAsset({ idAsset: this.idAsset });
          break;
        case 2:
          this.btnAssociaClienteHidden = true;
          this.$refs.cmpStoricoStatiComponent.loadData(this.pathResourceStatiStorico, { idGestioneAttivitaProgetti: this.idAsset });
          break;
      }
    },
    onAfterRimuoviAssociazioneCliente() {},
    onClickAssociaCliente() {
      let me = this;
      me.$refs.cmpGestioneAttivitaClientiListSelectModal.show("Clienti", me.idAsset);
    },
    onAssocizioneClienteAvvenuta() {
      this.$refs.cmpGestioneAttivitaClientiListComponent.loadFromAsset(this.pathResourceClientiAsset + "/" + this.idAsset, {});
    },
    onClickCambiaStato() {
      this.$refs.cmpStateChangeModalComponent.show({ idGestioneAttivitaProgetti: this.idAsset }, this.pathResourceStati, this.pathResourceAggiornaStato);
    },
    onCambioStatoSuccess() {
      this.$refs.cmpGestioneAttivitaProgettoViewComponent.loadData();
    },
  },
};
</script>

<style></style>
